module.exports = __webpack_public_path__ + "static/img/son2_active.dbc2ae9f.png";